<template>
    <div class="calendar">
        <div class="cal-top">
            <span class="cal-title">人员考勤日历</span>
            <DatePicker type="month" placement="bottom-end" placeholder="请选择"
                        :clearable="false" :options="options"
                        :value="currDate" @on-change="handleDate" ></DatePicker>
            <div style="margin-left: 40px">
                <div class="aFlex">
                    <div class="cal-dot green" style="margin-right: 10px"></div>正常考勤
                </div>
                <div class="aFlex">
                    <div class="cal-dot red" style="margin-right: 10px"></div>未考勤
                </div>
            </div>
        </div>
        <div class="cal-box">
            <!-- 星期 -->
            <ul class="cal-weeks">
                <li class="cal-item">周一</li>
                <li class="cal-item">周二</li>
                <li class="cal-item">周三</li>
                <li class="cal-item">周四</li>
                <li class="cal-item">周五</li>
                <li class="cal-item">周六</li>
                <li class="cal-item">周日</li>
            </ul>
            <!-- 日期 -->
            <ul class="cal-days">
                <Spin fix v-if="loading"></Spin>
                <!-- 核心 v-for循环 每一次循环用<li>标签创建一天 -->
                <li class="cal-item" v-for="(item,index) in days" :key="index">
                    <!-- 不是本月 -->
                    <div v-if="item.otherMonth" >
                        <span class="cal-item-other">{{ item.day}}</span>
                    </div>
                    <!-- 本月 -->
                    <div  v-else class="cal-item-conten">
                        <span>{{ item.day}}</span>
                        <div class="cal-dot" :class="checkType(item.flag)"></div>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>
<style scoped>
    .calendar{
        width: 700px;
    }
    .cal-top{
        display: flex;
        align-items: center;
        height: 80px;
    }
    .cal-title{
        font-size: 16px;
        color: #333333;
        font-weight: 700;
        margin-right: 20px;
    }
    .cal-dot{
        width: 15px;
        height: 15px;
        border-radius: 50%;
    }
    .cal-dot.green{
        background-color: #99CC33;
    }
    .cal-dot.red{
        background-color: #CC3300;
    }
    .cal-dot.gray{
        background-color: #ccc;
    }
    .cal-box{
        border-top: 1px solid #dcdee2;
        border-left: 1px solid #dcdee2;
        position: relative;
    }
    .cal-weeks,.cal-days{
        display: flex;
        flex-wrap: wrap;
        position: relative;
    }
    /* 每一项 */
    .cal-item{
        width:14.2857% ;
        padding: 10px 5px;
        text-align: center;
        border-right:1px solid #dcdee2;
        border-bottom:1px solid #dcdee2;
    }
    /* 星期 */
    .cal-weeks .cal-item{
        background-color: #F5F5F5;
        font-weight: 700;
        font-size: 14px;
        color: #333333;
    }
    /* 天 */
    .cal-days .cal-item{
        height: 60px;
    }
    .cal-item-conten{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .cal-item-other{
        color: #cccccc;
    }
</style>
<script>
    export default {
        data(){
            return {
                // 日期配置
                options: {
                    disabledDate (date) {
                        return date && date.valueOf() > Date.now();
                    }
                },
                loading:false,
                // 当前日期
                currDate:'',
                // 当前年
                currentYear: 2020,
                // 当前月份
                currentMonth: 2,
                // 当前周数
                currentWeek: 5,
                // 当前日数
                currentDay: 26,
                days: [],
                arrDate: []
            };
        },
        props: {
            workerId:{
                type: [String,Number]
            },
            corpId:{
                type: [String,Number]
            },
            projectId:{
                type: [String,Number]
            },
        },
        computed: {

        },
        created(){
            const date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month > 9 ? month : '0' + month;
            this.currDate=`${year}-${month}`;
            // this.currDate=`2019-03`;
            this.initData();
            this.getCheckList();
        },
        mounted(){
        },
        watch: {

        },
        methods: {
            checkType(flag){
                let cstr='';
                if (flag){
                    cstr='green';
                }else {
                    cstr='red';
                }
                if (flag === 3){
                    cstr='gray';
                }
                // switch (type) {
                //     case 1:
                //         cstr='red';
                //         break;
                //     case 2:
                //         cstr='green';
                //         break;
                //     default:
                //         cstr='';
                // }
                return cstr;
            },
            // 获取考勤列表数据
            getCheckList(){
                this.loading=true;
                this.axios({
                    method: 'get',
                    url: '/project/workers/calendarV2',
                    params:{
                        // workerId:'10344',
                        workerId:this.workerId,
                        projectId:this.projectId,
                        corpId:this.corpId,
                        date:this.currDate,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.arrDate=response.data.data.calendar;
                        this.setCheckList();
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
            // 日期改变
            handleDate(str){
                this.currDate=str;
                this.initData();
                this.getCheckList();
            },
            initData() {
                let cur=new Date(this.currDate);
                // 月的第一天时间对象
                let firstDate = new Date(this.formatDate(cur.getFullYear(),cur.getMonth() + 1,1));
                // 第一天的年
                this.currentYear = firstDate.getFullYear();
                // 第一天的月
                this.currentMonth = firstDate.getMonth() + 1;
                // 第一天的日数
                this.currentDay = firstDate.getDate();
                // 第一天的星期数
                this.currentWeek = firstDate.getDay(); // 1...6,0
                if (this.currentWeek === 0) {
                    this.currentWeek = 7;
                }
                var str = this.formatDate(this.currentYear , this.currentMonth, this.currentDay);
                this.days=[];
                // 第一天的周天数
                for (let i = this.currentWeek - 1; i >= 0; i--) {
                    let d = new Date(str);
                    d.setDate(d.getDate() - i);
                    let day=d.getDate();
                    day = day > 9 ? day : '0' + day;
                    let dayobject={
                        otherMonth:d.getMonth()+1 !== this.currentMonth,
                        day:day,
                    };
                    this.days.push(dayobject);//将日期放入data 中的days数组 供页面渲染使用
                }
                // 剩下的周天数
                for (var i = 1; i <= 42 - this.currentWeek; i++) {
                    let d = new Date(str);
                    d.setDate(d.getDate() + i);
                    let day=d.getDate();
                    day = day > 9 ? day : '0' + day;
                    let dayobject={};
                    dayobject = {
                        otherMonth:d.getMonth()+1 !== this.currentMonth,
                        day:day,
                        flag: false
                    };
                    this.days.push(dayobject);
                }
            },
            setCheckList () {
                for (let j=0;j<this.days.length;j++){
                    for (let i=0;i<this.arrDate.length;i++){
                        let currDay=this.currDate+'-'+ this.days[j].day;
                        if(this.arrDate[i].date === currDay ){
                            const obj = this.days[j];
                            obj.flag = this.arrDate[i].flag;
                            if(new Date(this.arrDate[i].date).getTime() > Date.now()) {
                                obj.flag = 3;
                            }
                            this.$set(this.days, j, obj);
                            break;
                        }
                    }
                }
            },
            // 返回 类似 2016-01-02 格式的字符串
            formatDate(year,month,day){
                var y = year;
                var m = month;
                if(m<10) m = "0" + m;
                var d = day;
                if(d<10) d = "0" + d;
                return y+"-"+m+"-"+d
            },
        }
    };
</script>

